import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/awarenessWelcome.css";
import useTranslation from "../hooks/useTranslation";

function AwarenessWelcome({ gameData, updateProgress }) {
  const navigate = useNavigate();
  const { t, language } = useTranslation();

  // Mapeo de idiomas a sus URLs y códigos de país
  const moduleLinks = {
    en: { url: "https://greenscape-project.eu/ed-ma/#", code: "EN" },
    es: { url: "https://greenscape-project.eu/es/ed-ma/", code: "ES" },
    el: { url: "https://greenscape-project.eu/el/ed-ma/", code: "EL" },
    bg: { url: "https://greenscape-project.eu/bg/ed-ma/", code: "BG" },
    fi: { url: "https://greenscape-project.eu/fi/ed-ma/", code: "FI" },
    cs: { url: "https://greenscape-project.eu/cs/ed-ma/", code: "CS" }
  };

  // Obtener el enlace correspondiente al idioma actual
  const currentModuleLink = moduleLinks[language] || moduleLinks.en;

  const handleContinue = () => {
    navigate('/awareness-instructions');
  };

  return (
    <div className="awareness-welcome-container">
      <div className="awareness-welcome-content">
        <div className="awareness-welcome-header">
          <h1 className="game-title">{t('awarenessWelcome.title')}</h1>
          <h2 className="game-subtitle">{t('awarenessWelcome.subtitle')}</h2>
        </div>

        <div className="welcome-info-box">
          <h2 className="urgency-title">{t('awarenessWelcome.urgencyTitle')}</h2>
          
          <div className="welcome-content-text">
            <p>{t('awarenessWelcome.urgencyText')}</p>
            <p>{t('awarenessWelcome.welcomeText')}</p>
            <p>{t('awarenessWelcome.contextText')}</p>
            <p className="preparation-text">{t('awarenessWelcome.preparationText')}</p>
          </div>

          <div className="welcome-buttons-container">
            {/* Enlace al módulo según el idioma seleccionado */}
            <a 
              href={currentModuleLink.url} 
              target="_blank" 
              rel="noreferrer"
              className="module-link-welcome"
            >
              <span className="module-code-welcome">{currentModuleLink.code}</span>
              <span className="module-arrow-welcome">↗</span>
            </a>
            <button className="continue-button-welcome" onClick={handleContinue}>
              {t('awarenessWelcome.continueButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AwarenessWelcome;

